// src/homepage/CTASection.tsx
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
    padding: 96px 0;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #FFFFFF 0%, #F5F5F5 50%, #C0C0C0 100%);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(153, 1, 71, 0.3) 50%,
                transparent 100%
        );
    }
`;

const BackgroundPattern = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.03;
    background-image: radial-gradient(circle at 25% 25%, #990147 2px, transparent 0),
    radial-gradient(circle at 75% 75%, #990147 2px, transparent 0);
    background-size: 60px 60px;
`;

const CTAContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 2rem;
    text-align: center;
    position: relative;
    z-index: 2;
`;

const CTATitle = styled(motion.h2)`
    font-size: 2.8rem;
    font-weight: 800;
    background: linear-gradient(135deg, #333333 0%, #990147 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 1.5rem;
    line-height: 1.1;

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`;

const CTASubtitle = styled(motion.p)`
    font-size: 1.2rem;
    color: #555555;
    line-height: 1.6;
    margin-bottom: 3rem;
    font-weight: 400;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
`;

const SecondaryButton = styled(motion.button)`
    padding: 1rem 2.5rem;
    font-size: 1.125rem;
    border: 2px solid #990147;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: transparent;
    color: #990147;
    font-weight: 700;

    &:hover {
        background: #990147;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(153, 1, 71, 0.2);
    }
`;

const ContactInfo = styled(motion.div)`
    margin-top: 3rem;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.05);
`;

const ContactText = styled.p`
    color: #555555;
    font-size: 1rem;
    margin: 0;
    font-weight: 500;
    
    strong {
        color: #990147;
        font-weight: 700;
    }
`;

const CTASection: React.FC = () => {
    return (
        <Section id="kontakt">
            <BackgroundPattern />
            <CTAContent>
                <CTATitle
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    Začnite svoj cestu k lepšiemu duševnému zdraviu.
                </CTATitle>

                <CTASubtitle
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    viewport={{ once: true }}
                >
                    Neurobíme prvý krok za vás. Kontaktujte nás ešte dnes a dohodnite si termín konzultácie.
                    Investícia do vášho duševného zdravia je investíciou do kvality vášho života.
                </CTASubtitle>

            </CTAContent>
        </Section>
    );
};

export default CTASection;